
export const NOTIFICATION_TYPES = {
    DEFAULT:'DEFAULT',
    ASK_UNMUTE_EVENT: 'ASK_UNMUTE_EVENT' 
}
export const ALERT_TYPES = {
    SUCCESS:'SUCCESS',
    FAILURE: 'FAILURE' 
}